module.exports = __webpack_public_path__ + "static/media/wood_floor_cracked.349651f7.png";